export const initStateIsabi = (
   Object.assign({
      data                  : [],
      municipality          : '',
      percentage            : 0,
      additional_percentage : 0,
      isabiTaxId            : '',
      actionForm            : false,
      budgets_unconfirmed   : [],
      modal_budget          : false,
      selected_folio        : '',
      date_payment          : '',
      way_payment           : '',
      budgets_confirmed     : [],
      amount_payment        : 0,
      item_isabi_budget     : [],
      isabiBudgetId         : ''
   })
);